import React, { useState, useEffect, useRef } from "react";
import Moment from "moment";
const { connection_platform } = require("../services/api");

const TimeCounterMinute = ({ horario, day, maxTime }) => {
  const [time, setTime] = useState(!isNaN(horario) ? horario * 1000 : 0); // Tempo atual
  const [days, setDays] = useState(day); // Dias
  const intervalRef = useRef(null); // Referência para o intervalo

  useEffect(() => {
    // Reinicia o contador sempre que o atendimento (horario/day) mudar.
    // Necessário porque, ao reordenar a lista, o react-virtualized reaproveita
    // a mesma instância do componente e apenas troca as props.
    const base = !isNaN(horario) ? horario * 1000 : 0;
    setTime(base);
    setDays(day);

    const startTime = Date.now() - base;

    intervalRef.current = setInterval(() => {
      setTime(Date.now() - startTime); // Atualiza o tempo decorrido
    }, connection_platform.milliseconds || 1000); // Define o intervalo

    return () => {
      // Limpa o intervalo ao desmontar / antes de reiniciar
      clearInterval(intervalRef.current);
    };
  }, [horario, day]); // Reexecuta quando o atendimento exibido muda

  useEffect(() => {
    // Atualiza os dias se necessário
    if (time >= 86400000) {
      // 86400000 ms = 1 dia
      const newDays = Math.floor(time / 86400000); // Calcula os dias completos
      setDays(newDays);
    }
  }, [time]); // Reexecuta sempre que o tempo muda

  // Formata o tempo para exibição
  const formattedTime = Moment.utc(time % 86400000).format("HH:mm:ss"); // Resto do dia em HH:mm:ss

  return (
    <span
      style={{
        color: maxTime && time > maxTime ? "#c90000" : "inherit",
        fontSize: "inherit",
      }}
    >
      {`${days > 0 ? `${days} ${days > 1 ? "dias" : "dia"} ` : ""}${formattedTime}`}
    </span>
  );
};

export default TimeCounterMinute;
